import { queryKeyFactory } from '@wyz/utils';
import { IBrandPaginationQuery } from '~/common/types';
import { CommonQueryKeys } from '~/common/api';

export const root = () => ['root'];
export const appContext = (userId: string) => ['me', userId];
export const appConfig = () => ['functional-config'];

export const tenants = queryKeyFactory({
  base: (tenantCode: string) => [...root(), 'tenants', tenantCode],
});
export const parameters = queryKeyFactory({
  base: () => ['parameters'],
  groups: function () {
    return [...this.base(), 'users.groups'];
  },
});

export const brands = queryKeyFactory({
  base: () => [...root(), 'brands'],
  paginate: (query: IBrandPaginationQuery) => [
    ...root(),
    'brands',
    'paginate',
    query,
  ],
});
export const supplierPlatforms = queryKeyFactory({
  base: () => [...root(), 'supplier-platforms'],
  paginate: function (query: unknown) {
    return [...this.base(), 'paginate', query];
  },
});

export const containerSuppliers = queryKeyFactory({
  base: () => [...CommonQueryKeys.root(), 'container-suppliers'],
  hqs: function () {
    return [...this.base(), 'hqs'];
  },
  byId: function (id: string) {
    return [...this.base(), 'byId', id];
  },
  imports: function () {
    return [...this.base(), 'imports'];
  },
});
